/**
 * @constant ABORT_ERROR
 * @description The type of the error thrown when the request is aborted by the user
 * @memberof module:fetch-utils
 */
export const ABORT_ERROR = Symbol('ABORT_ERROR');

/**
 * @constant RESPONSE_ERROR
 * @description The type of the error thrown when the request returns a status other that 200 - 299
 * @memberof module:fetch-utils
 */
export const RESPONSE_ERROR = Symbol('RESPONSE_ERROR');

/**
 * @constant FETCH_ERROR
 * @description The type of the error thrown when the request fails. For more information see {@link https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#checking_that_the_fetch_was_successful|handling errors during fetch}
 * @memberof module:fetch-utils
 */
export const FETCH_ERROR = Symbol('FETCH_ERROR');

/**
 * @constant TIMEDOUT_ERROR
 * @description The type of the error thrown when the request has timedout
 * @memberof module:fetch-utils
 */
export const TIMEDOUT_ERROR = Symbol('TIMEDOUT_ERROR');

export default {};
